// Lens sheet: mono caps keys (11px .08em ink-mute, the one sheet-key style), mono values right-aligned, rule-cell rows.
//   <Kv rows={[["Max severity", <Sev level={5} />], ["Behavior tags", <>8 <small>· 1 critical</small></>], ["YARA", null]]} none? className? />
//   a null / undefined / "" value renders data-none with `none` (default "—") in faint ink; put units in <small>
import type { ReactNode } from "react";
import { cx } from "./cx";

export type KvRow = readonly [ReactNode, ReactNode?];

export function Kv({ rows, none = "—", className }: { rows: readonly KvRow[]; none?: ReactNode; className?: string }) {
  return (
    <dl className={cx("kv", className)}>
      {rows.map(([k, v], i) => {
        const missing = v === undefined || v === null || v === "" || v === false;
        return (
          <div key={i}>
            <dt>{k}</dt>
            {missing ? <dd data-none="">{none}</dd> : <dd>{v}</dd>}
          </div>
        );
      })}
    </dl>
  );
}
